import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-11abaeaa")
const _hoisted_1 = {
  key: 1,
  class: "student-area"
}
const _hoisted_2 = { class: "inner flex-box jc-sb" }
const _hoisted_3 = { class: "control-btn-area flex-box jc-sa" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "btn-text back" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-s-fill ri-xl" }),
  /*#__PURE__*/_createTextVNode("戻る")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "btn-text next" }, [
  /*#__PURE__*/_createTextVNode("次へ"),
  /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-s-fill ri-xl" })
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_expired_screen = _resolveComponent("expired-screen")!
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_heading = _resolveComponent("heading")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_divider = _resolveComponent("divider")!
  const _component_chat_area = _resolveComponent("chat-area")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loader, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    (_ctx.showExpiredScreen)
      ? (_openBlock(), _createBlock(_component_expired_screen, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_header_menu, {
            showHeaderMenu: false,
            title: _ctx.roomObj.roomTitle
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", {
              class: "question-area",
              style: _normalizeStyle({ width: `${_ctx.leftWidth}%` })
            }, [
              _createVNode(_component_progress_bar, {
                completeVal: _ctx.completeVal,
                showPercentage: true,
                style: {"margin-top":"10px"}
              }, null, 8, ["completeVal"]),
              _createElementVNode("div", {
                class: "question-title-area",
                style: _normalizeStyle({
            opacity: _ctx.completeVal === 100 ? '0.5' : '1',
          })
              }, [
                _createVNode(_component_heading, {
                  level: 2,
                  fontSize: "xl"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.questionObj[_ctx.curQuestionId]?.body), 1)
                  ]),
                  _: 1
                })
              ], 4),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_custom_button, {
                  type: "circle",
                  class: _normalizeClass({
              'is-finished': _ctx.completeQuestions.length === 0,
            }),
                  centering: true,
                  width: 150,
                  height: 150,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.undoQuestion()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_custom_button, {
                  class: _normalizeClass({
              'is-finished':
                _ctx.completeVal === 100 || _ctx.roomObj.questionIdList?.length === 0,
            }),
                  type: "circle",
                  centering: true,
                  width: 150,
                  height: 150,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.completeQuestion()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ], 4),
            _createVNode(_component_divider, { onChangePosition: _ctx.changeWidth }, null, 8, ["onChangePosition"]),
            _createVNode(_component_chat_area, {
              roomId: _ctx.id,
              style: _normalizeStyle({ width: `${99 - _ctx.leftWidth}%` })
            }, null, 8, ["roomId", "style"])
          ])
        ]))
  ], 64))
}